import { getRouteView } from '@/modules/activityTracker/referers';

// Cloudflare Turnstile only accepts `[a-zA-Z0-9_-]`, up to 32 characters, for
// the `action` parameter. See:
// https://developers.cloudflare.com/turnstile/get-started/client-side-rendering/widget-configurations/
const ACTION_MAX_LENGTH = 32;
const ACTION_FALLBACK = 'unknown';
const DISALLOWED_CHARS = /[^a-zA-Z0-9_-]/g;

/**
 * Derives a Cloudflare Turnstile `action` value from the current route so the
 * Turnstile dashboard can be filtered by the page the widget rendered on.
 *
 * Reuses `getRouteView` — the same source as the Turnstile `route:` metric tag —
 * so the Cloudflare analytics line up with our Datadog metrics. Route names are
 * dotted (e.g. `magiclink.request.view`), so they are sanitised to satisfy the
 * character and length constraint noted above, falling back to `unknown` for an
 * unmatched route.
 */
export function getTurnstileAction(pathname: string): string {
  const sanitized = getRouteView(pathname).replace(DISALLOWED_CHARS, '_');

  return (sanitized || ACTION_FALLBACK).slice(0, ACTION_MAX_LENGTH);
}
